import React, { useState } from "react";
import { Button, Card, Form, Row, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";
import { model, validationModel } from "./AddBankModel";
import { addBank } from "app/services/AdminServices/bankService";
import { useNavigate } from "react-router-dom";
import "./AddBank.css";

const AddBank = () => {
  const [state, setState] = useState({
    model,
  });
  const [isShow, setIsShow] = useState(false);
  const navigate = useNavigate();

  const addNewBank = async (values) => {
    debugger;
    setIsShow(true);
    const data = await addBank(values);
    if (data && data.status === "Success") {
      navigate("/admin/bank/bank-lists");

      setIsShow(false);
    } else {
      console.log(data);
      setIsShow(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Add New Bank</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[
          { name: "Bank Lists", path: "/admin/bank/bank-lists" },
          { name: "Add New Bank" },
        ]}
      ></Breadcrumb>

      <Card className="m-auto pt-4 mb-3" style={{ width: "90%" }}>
        <Card.Body>
          <Formik
            initialValues={state.model}
            validationSchema={validationModel}
            onSubmit={addNewBank}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <div>
                      <div className="form-group">
                        <label
                          htmlFor="accountHolderName"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Account Holder Name
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="accountHolderName"
                          id="accountHolderName"
                          className={
                            touched.accountHolderName &&
                            errors.accountHolderName
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Name"
                          value={values.accountHolderName}
                          error={errors.accountHolderName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.accountHolderName &&
                            errors.accountHolderName}
                        </p>
                      </div>
                    </div>
                  </Row>
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="bankName"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Bank Name
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="bankName"
                          id="bankName"
                          className={
                            touched.bankName && errors.bankName
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Bank Name"
                          value={values.bankName}
                          error={errors.bankName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.bankName && errors.bankName}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="accountNumber"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          A/C Number
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="accountNumber"
                          id="accountNumber"
                          className={
                            touched.accountNumber && errors.accountNumber
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Account Number"
                          value={values.accountNumber}
                          error={errors.accountNumber}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.accountNumber && errors.accountNumber}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="ifscCode"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          IFSC Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="ifscCode"
                          id="ifscCode"
                          className={
                            touched.ifscCode && errors.ifscCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="IFSC Code"
                          value={values.ifscCode}
                          error={errors.ifscCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.ifscCode && errors.ifscCode}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="branch"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Branch
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="branch"
                          id="branch"
                          className={
                            touched.branch && errors.branch
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Branch"
                          value={values.branch}
                          error={errors.branch}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.branch && errors.branch}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="shortCode"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Bank Short Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="shortCode"
                          id="shortCode"
                          className={
                            touched.shortCode && errors.shortCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Bank Short Code"
                          value={values.shortCode}
                          error={errors.shortCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.shortCode && errors.shortCode}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="swiftCode"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Swift Code
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="swiftCode"
                          id="swiftCode"
                          className={
                            touched.swiftCode && errors.swiftCode
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Swift Code"
                          value={values.swiftCode}
                          error={errors.swiftCode}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.swiftCode && errors.swiftCode}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="address"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Address
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          name="address"
                          id="address"
                          className={
                            touched.address && errors.address
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Address"
                          value={values.address}
                          error={errors.address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.address && errors.address}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="remarks"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Remarks
                        </label>
                        <input
                          type="text"
                          name="remarks"
                          id="remarks"
                          className={
                            touched.remarks && errors.remarks
                              ? "error form-control customInput"
                              : "form-control customInput"
                          }
                          placeholder="Remarks"
                          value={values.remarks}
                          error={errors.remarks}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        <p className="text-danger">
                          {touched.remarks && errors.remarks}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-group">
                        <label
                          htmlFor="status"
                          className="font-weight-bold"
                          style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight: "600",
                          }}
                        >
                          Status
                        </label>
                        <div className="custom-control custom-switch ml-2">
                          <Form>
                            <Form.Check // prettier-ignore
                              type="switch"
                              size={"20px"}
                              value={values.status}
                              error={errors.status}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="status"
                              id="status"
                              label={
                                <label
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "15px",
                                    marginTop: "-15px",
                                    color: "green",
                                  }}
                                >
                                  Active
                                </label>
                              }
                              color="green"
                            />
                          </Form>
                          {/* <label
                            className="custom-control-label"
                            htmlFor="status"
                          >
                            Active
                          </label> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-12 text-center">
                      {isShow ? (
                        <Button variant="primary" size="md" disabled>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            style={{ marginRight: "10px" }}
                          />
                          Saving
                        </Button>
                      ) : (
                        <button type="submit" className="btn btn-primary ">
                          Submit
                        </button>
                      )}
                    </div>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AddBank;
